import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";

import { tw } from "@/utils";

interface CheckboxProps
  extends React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> {
  hasError?: boolean;
}

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  CheckboxProps
>(({ className, hasError = false, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={tw(
      "size-4 rounded border border-neutral-200",
      "disabled:cursor-not-allowed disabled:opacity-50",
      "data-[state=checked]:border-primary-500 data-[state=checked]:bg-primary-100 data-[state=checked]:text-primary-500",
      hasError && "border-error-700",
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={tw("text-current flex items-center justify-center")}
    >
      <Check className="h-4 w-4" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
